<template>
  <div class="resources">
    <!-- Ver2 -->
    <div id="here">
      <!-- ver.3 -->
      <b-card-group deck>
        <!-- <b-card img-src="https://i.imgur.com/gPIqZCB.png" img-alt="Card image" img-top class="mb-3"> -->
        <b-card class="mb-3 special" style="background-color: rgba(252, 234, 164,0.2);">
          <b-card-text>
            <h2 class="card-title" style="text-align: center; font-weight: bold;">2021 Open Access Week</h2>
            <br><br>
            <b-row>
              <b-col>
            <h4 style="text-align: left; font-weight: bold;">LOGOs</h4>
            <!-- <b-table borderless :items="logos"/> -->
            <br>
               <b-row class="text-center" style="padding-left:52px;">
              <b-col cols="3.5">
                <br>
                <h5 style="text-align: left;">986x310&nbsp;&nbsp;</h5>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/file/d/1aj5dm3-n3UCa-Naq5TTmBGQP3-6ZITGC/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">PNG</a>
                <a href="https://drive.google.com/file/d/1aYv8U6CexIDTuNHU4YdGFbMQ-IVYsWF_/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">&nbsp;&nbsp;AI&nbsp;&nbsp;</a>
              </b-col>
            </b-row>
            <b-row class="text-center" style="padding-left:52px;">
              <b-col cols="3.5">
                <br>
                <h5 style="text-align: left;">1024x512</h5>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/file/d/1b3CzK8GqcpWkFOcMO--OHgiLEemoYuvb/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">PNG</a>
                  <a href="https://drive.google.com/file/d/1aVe-SgXrwef_TSAllDLRb2S8DeGUxpO2/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">&nbsp;&nbsp;AI&nbsp;&nbsp;</a>
              </b-col>
            </b-row>

            <b-row class="text-center" style="padding-left:52px;">
              <b-col cols="3.5">
                <br>
                <h5 style="text-align: left;">1200x630</h5>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/file/d/1akfrWEoYTo1KqhoekfR9SOebErNN7jSl/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">PNG</a>
                  <a href="https://drive.google.com/file/d/1b1-_n_-KSvliqpclErKDrPgz-quq272L/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">&nbsp;&nbsp;AI&nbsp;&nbsp;</a>
              </b-col>
            </b-row>
            </b-col>

              <b-col>

            <h4 style="text-align: left; font-weight: bold;">POSTERs</h4>
            <!-- <b-table borderless :items="logos"/> -->
            <br>
               <b-row class="text-center" style="padding-left:52px;">
              <b-col cols="3.5">
                <br>
                <h5 style="text-align: left;">Letter&nbsp;&nbsp;&nbsp;</h5>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/file/d/1arVVWW7as9Rccfeujl9P7kZOA_OQ3SVs/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">PDF</a>
                <a href="https://drive.google.com/file/d/1au1a8J1ynaFgDwqcDwWqCKy-3Uf4Pv4C/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">&nbsp;&nbsp;AI&nbsp;&nbsp;</a>
              </b-col>
            </b-row>
            <b-row class="text-center" style="padding-left:52px;">
              <b-col cols="3.5">
                <br>
                <h5 style="text-align: left;">Legal&nbsp;&nbsp;&nbsp;&nbsp;</h5>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/file/d/1b7OJh1V4oY78FwpMSVeW0A9d7PCwvYkB/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">PDF</a>
                  <a href="https://drive.google.com/file/d/1auAqB6eylnDxjYYI6-UODObpUmCAa-n9/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">&nbsp;&nbsp;AI&nbsp;&nbsp;</a>
              </b-col>
            </b-row>
            <b-row class="text-center" style="padding-left:52px;">
              <b-col cols="3.5">
                <br>
                <h5 style="text-align: left;">Tabloid&nbsp;</h5>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/file/d/1anwgYV1qxwszwXLlZpmld15w7NrI47w5/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">PDF</a>
                  <a href="https://drive.google.com/file/d/1ajhl6kPFspUvy3qfES4MW8RC0NZZQd1o/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">&nbsp;&nbsp;AI&nbsp;&nbsp;</a>
              </b-col>
            </b-row>
            <b-row class="text-center" style="padding-left:52px;">
              <b-col cols="3.5">
                <br>
                <h5 style="text-align: left;">A3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</h5>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/file/d/1b-GKgdGMJpQblkqECpA8MYKQv0OJqnO3/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">PDF</a>
                  <a href="https://drive.google.com/file/d/1az0UkMZUtnX9yEI2iZelkn3zIgl1EkGa/view?usp=sharing" class="btn custom1" style="background-color:#5662eb; color: white;">&nbsp;&nbsp;AI&nbsp;&nbsp;</a>
              </b-col>
            </b-row>
          </b-col>
            </b-row>
          </b-card-text>
        </b-card>
        <div class = "special">

        </div>
        <b-card class="mb-3" style="background-color: rgba(252, 234, 164,0.2);">
          <b-card-text>
            <h2 class="card-title" style="text-align: center; font-weight: bold;">OA倡議文件</h2>
            <br><br>
            <b-row class="text-center" style="padding-left: 2%">
              <b-col cols="7">
                <br>
                    <h4 style="text-align: left; font-weight: bold;">開放取用簡介</h4>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/open?id=1Hf9wuuKp3Owxkv8elUYrYbZpTdAB2tgI" class="btn custom" style="background-color:#5662eb; color: white;">JPG</a>
                <a href="https://drive.google.com/open?id=1R7iwnPAqd5zHIPa-SYORlWz4VHWaKv9j" class="btn custom" style="background-color:#5662eb; color: white;">AI</a>
              </b-col>
              <!-- <b-col></b-col> -->
            </b-row>
            <b-row class="text-center" style="padding-left: 2%">
              <b-col cols="7">
                <br>
                    <h4 style="text-align: left; font-weight: bold;">我們支持開放取用</h4>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/open?id=1N9ggaIsj1Lh_4_HJqhZkkcdhc1-w2i59" class="btn custom" style="background-color:#5662eb; color: white;">JPG</a><a href="https://drive.google.com/open?id=1Lk58loZVeKzHmu3SUXTw3ShYKuYZwPk2" class="btn custom" style="background-color:#5662eb; color: white;">AI</a>
              </b-col>
            </b-row>
            <b-row class="text-center" style="padding-left: 2%">
              <b-col cols="7">
                <br>
                    <h4 style="text-align: left; font-weight: bold;">館員能如何支持開放取用</h4>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/open?id=1t5w_U7M6VWlEA4-GcKwRmG44kv7QITen" class="btn custom" style="background-color:#5662eb; color: white;">JPG</a><a href="https://drive.google.com/open?id=15l5Sj3TR-wanUJbzGweyE69Qi_PGJ5fG" class="btn custom" style="background-color:#5662eb; color: white;">AI</a>
              </b-col>
            </b-row>
            <b-row class="text-center" style="padding-left: 2%">
              <b-col cols="7">
                <br>
                    <h4 style="text-align: left; font-weight: bold;">教師能如何支持開放取用</h4>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/open?id=1EncXeDvUKnzVbTA-ElWj8SGwudoXIG9y" class="btn custom" style="background-color:#5662eb; color: white;">JPG</a><a href="https://drive.google.com/open?id=1fsNGBA4IoUICq88ZgOpG0SaZD8FDqtMv" class="btn custom" style="background-color:#5662eb; color: white;">AI</a>
              </b-col>
            </b-row>
            <b-row class="text-center" style="padding-left: 2%">
              <b-col cols="7">
                <br>
                    <h4 style="text-align: left; font-weight: bold;">研究經費獎補助機構可以如何提倡開放取用</h4>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/open?id=1vckhjo2X-hET9yin5Q7sofle6IoMAK_e" class="btn custom" style="background-color:#5662eb; color: white;">JPG</a><a href="https://drive.google.com/open?id=1ZNfvqAvJ3zoIWliKFdd6jWcrNH66TsVd" class="btn custom" style="background-color:#5662eb; color: white;">AI</a>
              </b-col>
            </b-row>
            <b-row class="text-center" style="padding-left: 2%">
              <b-col cols="7">
                <br>
                    <h4 style="text-align: left; font-weight: bold;">大學與行政部門可以如何提倡開放取用</h4>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://drive.google.com/open?id=1p28ShCEd3l03MH0nP9Z9wQOM8bWkG9xh" class="btn custom" style="background-color:#5662eb; color: white;">JPG</a><a href="https://drive.google.com/open?id=1M3t8UMptEO4ebs3eqA1Zp-Hoanh6XlNq" class="btn custom" style="background-color:#5662eb; color: white;">AI</a>
              </b-col>
            </b-row>
             <b-row class="text-center" style="padding-left: 2%">
              <b-col cols="7">
                <br>
                    <h4 style="text-align: left; font-weight: bold;">Open Access 開放取用完攻手冊</h4>
              </b-col>
              <b-col style="text-align: left;">
                <a href="https://concert.stpi.narl.org.tw/uploads/schedule_file/speaker_file/file/605/Open_Access_%E9%96%8B%E6%94%BE%E5%8F%96%E7%94%A8%E5%AE%8C%E6%94%BB%E6%89%8B%E5%86%8A_20211005upload.pdf" class="btn custom" style="background-color:#5662eb; color: white;">PDF</a>
              </b-col>
            </b-row>

          </b-card-text>
        </b-card>

      </b-card-group>
    </div>
  </div>

</template>
<script>
export default {

  name: 'Resources'

}

</script>
<style lang="css">
.resources{
  background-color: rgba(248, 194, 88,0.1);
}
.custom {
    width: 95.5px !important;
}
.custom1 {
    width: 97px !important;
}
p {
  /*padding-left: 5%;*/
  text-align: left;
  font-weight: bold;

}

@media (min-width: 400px) and (max-width: 500px) {

  .special {

    margin-right:0px;

  }
  div#here{
    padding: 30px 10px 30px 10px;
  }

}

@media (min-width: 1200px) {

  .special {

    margin-right:100px;

  }
  div#here{
    padding: 60px 100px 60px 100px;
  }

}

.card-columns {
  /*padding: 20px 20px 30px 30px;*/

  @include media-breakpoint-only(lg) {
    column-count: 4;
  }

  @include media-breakpoint-only(xl) {
    column-count: 5;
  }
}

</style>
